<template>
<div class="track-wrap">
    <div  v-if="nPermissions!=0 && isShowPage">
        <div class="tab-wrap">
            <template v-for="item in arrTab">
                <div class="tab-item" :class="{'tab-item-active':item.id==nShowTabId}" v-if="item.show">
                    <span @click="toChangeTab(item.id)">{{item.name}}</span>
                </div>
            </template>
        </div>
        <div class="data-content">
            <router-view></router-view>
        </div>
    </div>
    <div v-if="nPermissions==0 && isShowPage">
        <div class="tips">暂无查看权限</div>
    </div>
</div>
</template>

<script>
import oTrack from "@/js/track/indexv2";
import {getWxSingleConfig} from "@/js/wx";
export default {
    name: "trackIndex",
    data(){
        return{
            isShowPage:false,
            arrTab:[
                {id:1,name:'开发者看板',show:false},
                {id:2,name:'管理看板',show:false},
                {id:3,name:'直销员看板',show:false},
                {id:4,name:'数据报表',show:false},
            ],//看板栏目选项
            nShowTabId:1,//激活的tab id
            nPermissions:0,//可查看权限   1:总部人员  2:非总部人员  0:无权限
        }
    },
    created() {
        $init(()=>{
            getWxSingleConfig().then((res) => {
                wx.ready(() => {
                })
            })
            this.getAuth()
        })
    },
    methods:{
        // 获取权限
        getAuth(){
            this.$store.commit('loadSwitch',true)
            oTrack.auth().then(res=>{
                console.log(res.data.data.result,'权限')
                let result = res.data.data.result
                if(result.is_admin>0){
                    // 总部人员查看所有
                    this.nPermissions=1
                }else if(result.is_manager>0 ||  result.is_area>0 ||  result.sell_id>0){
                    // 非总部人员
                    this.nPermissions=2
                }else{
                    // 无权限
                    this.nPermissions=0
                }
                // 判断权限,展示看板
                switch (this.nPermissions){
                    case 1://总部人员
                        this.arrTab[0].show=true
                        this.arrTab[1].show=true
                        this.arrTab[2].show=true
                        this.arrTab[3].show=true
                        this.nShowTabId=1
                        this.$router.push('/track/v2/developer')
                        break;
                    case 2://直销员
                        this.arrTab[3].show=true
                        this.nShowTabId=4
                        this.$router.push('/track/v2/report')
                        break;
                }
                this.isShowPage=true
                this.$store.commit('loadSwitch',false)
            })
        },
        // 切换tab
        toChangeTab(id){
            this.nShowTabId=id
            switch (this.nShowTabId){
                case 1:
                    this.$router.push('/track/v2/developer')
                    break;
                case 2:
                    this.$router.push('/track/v2/management')
                    break;
                case 3:
                    this.$router.push('/track/v2/seller')
                    break;
                case 4:
                    this.$router.push('/track/v2/report')
                    break;

            }
        },
    }
}
</script>

<style scoped lang="scss">
*{
    user-select: none!important;
}
.track-wrap{
    width: 100vw;
    height: 100vh;
    .tab-wrap{
        width: 100%;
        height: 135px;
        background: url("~@/assets/images/track/t-bgc.png") no-repeat center/cover;
        box-sizing: border-box;
        padding-top: 24px;
        display: flex;
        .tab-item{
            flex: 1;
            text-align: center;
            position: relative;
            span{
                display: inline-block;
                height: 68px;
                line-height: 68px;
                font-size: 24px;
                font-weight: 400;
                padding: 0 30px;
                color: rgba(255,255,255,0.7);
                box-sizing: border-box;
                border: 2px solid rgba(255,255,255,0);
            }
            &:nth-child(2){
                &:after{
                    content: '';
                    position: absolute;
                    width: 2px;
                    height: 32px;
                    background: rgba(255,255,255,0.07);
                    right: 0;
                    top: 20%;
                    //transform: translateY(-50%);
                }
                &:before{
                    content: '';
                    position: absolute;
                    width: 2px;
                    height: 32px;
                    background: rgba(255,255,255,0.07);
                    left: 0;
                    top: 20%;
                    //transform: translateY(-50%);
                }
            }
        }
        .tab-item-active{
            span{
                color: #ffffff;
                background: rgba(255,255,255,0.2);
                box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.09);
                border-radius: 34px;
                border: 2px solid rgba(255,255,255,0.2);
            }
        }
    }
    .data-content{
        width: 100vw;
        height: calc(100vh - 135px);
        background: #ffffff;
        transform: translateY(-15px);
        border-radius: 15px 15px 0 0;
        overflow-x: hidden;
        overflow-y: scroll;

    }
}
.tips{
    margin-top: 100px;
    text-align: center;
}
</style>
